import React, { useEffect } from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import { useBanners } from '../hooks/useApi';

interface HeroSectionProps {
  onBookingClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onBookingClick }) => {
  const { banners, loading, fetchBanners } = useBanners();
  const mainBanner = banners[0];

  useEffect(() => {
    fetchBanners();
  }, []); // Use first banner as main hero content

  return (
    <section id="home" className="bg-gradient-hero text-white py-5 position-relative overflow-hidden">
      {/* Background Pattern */}
      <div className="position-absolute top-0 end-0 opacity-10" style={{fontSize: '20rem', lineHeight: '1', color: 'rgba(251,176,21,0.1)'}}>
        🔧
      </div>
      
      <Container className="position-relative">
        <Row className="align-items-center" style={{ minHeight: '80vh' }}>
          <Col lg={6} md={12} className="mb-4 mb-lg-0">
            <div className="mb-3">
              <Badge bg="yellow" text="dark" className="px-3 py-2 fs-6 me-2">
                ⭐ Since 2011
              </Badge>
              <Badge bg="outline-warning" className="px-3 py-2 fs-6">
                🏆 13+ Years Experience
              </Badge>
            </div>
            
            {loading ? (
              <div className="placeholder-glow">
                <h1 className="placeholder col-8 mb-3"></h1>
                <p className="placeholder col-6 mb-3"></p>
              </div>
            ) : (
              <>
                <h1 className="display-6 display-md-4 display-lg-3 fw-bold mb-3 lh-1">
                  {mainBanner?.title || "Expert Car Repair & Service in Indore"}
                </h1>
                
                <p className="mb-3 fs-6">
                  {mainBanner?.description || "Professional car repair and service center in Limbodi, Indore. 13+ years experience with quality service."}
                </p>
              </>
            )}
            
            {/* Key Features - Mobile Optimized */}
            <div className="d-block d-md-none mb-3">
              <div className="row g-2">
                <div className="col-6">
                  <div className="bg-yellow bg-opacity-10 rounded p-2 text-center">
                    <div className="text-yellow fs-5 mb-1">✅</div>
                    <small className="fw-bold">Expert Technicians</small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="bg-yellow bg-opacity-10 rounded p-2 text-center">
                    <div className="text-yellow fs-5 mb-1">⚡</div>
                    <small className="fw-bold">Same Day Service</small>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Key Features - Desktop */}
            <Row className="mb-4 d-none d-md-flex">
              <Col sm={6} xs={12}>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">✅</span>
                  <span className="fs-6">Expert Technicians</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">⚡</span>
                  <span className="fs-6">Same Day Service</span>
                </div>
              </Col>
              <Col sm={6} xs={12}>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">💰</span>
                  <span className="fs-6">Transparent Pricing</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">🛡️</span>
                  <span className="fs-6">Quality Guarantee</span>
                </div>
              </Col>
            </Row>
            
            <div className="d-grid d-md-flex gap-2 gap-md-3">
              <Button 
                variant="warning" 
                size="lg" 
                onClick={onBookingClick}
                className="fw-bold py-3 text-dark"
              >
                📞 {mainBanner?.button_text || "Book Service Now"}
              </Button>
              <Button 
                variant="outline-light" 
                size="lg" 
                href="#services"
                className="fw-bold py-3"
              >
                🔍 View Services
              </Button>
            </div>
            
            {/* Emergency Contact - Mobile Optimized */}
            <div className="mt-3 p-2 bg-red rounded-3 d-block d-md-none">
              <div className="text-center">
                <div className="fw-bold mb-1">24/7 Emergency</div>
                <div className="fs-6">📞 +91 98765 43210</div>
              </div>
            </div>
            
            {/* Emergency Contact - Desktop */}
            <div className="mt-4 p-3 bg-red rounded-3 d-none d-md-block">
              <div className="d-flex align-items-center">
                <span className="fs-4 me-2">⚠️</span>
                <div>
                  <strong>24/7 Emergency Service</strong><br/>
                  <span className="fs-6 fs-lg-5">📞 +91 98765 43210</span>
                </div>
              </div>
            </div>
          </Col>
          
          <Col lg={6} md={12}>
            <div className="text-center">
              <img 
                src={mainBanner?.image || "/banner_1.png"}
                alt="Laxmi Tyres & Motors - Professional Car Service" 
                className="img-fluid rounded-4 shadow-lg"
                style={{maxHeight: '400px', minHeight: '250px', width: '100%', objectFit: 'cover'}}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;